/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["yarim tun", "tush payti", "ertalab", "kunduzi", "kechqurun", "kechasi"], u, u], u, ["00:00", "12:00", ["06:00", "11:00"], ["11:00", "18:00"], ["18:00", "22:00"], ["22:00", "06:00"]]];
